<template>
  <div v-if="shouldShow" class="px-3 md:px-6" data-test-id="login-in-prompt">
    <ContextualMessage
      :show-icon="false"
      class="bg-yellow-100 rounded-lg font-medium"
    >
      <a :href="loginUrl">Log in</a> to recruit {{ similarAthletesCount }}+ athletes in the class of {{ classYear }}
    </ContextualMessage>
  </div>
</template>
<script>
import { ContextualMessage } from "@sportsrecruits/playbook";
import { mapGetters } from "vuex";

export default {
  name: 'LogInPrompt',
  components: {
    ContextualMessage,
  },
  computed: {
    ...mapGetters("userData", ["isLoggedOut", "isUsingProfileKey", "authUsingProfileKey"]),
    ...mapGetters("athleteProfile", [
      "classYear",
      "similarUncommittedAthletesCount",
    ]),
    hasValidClassYear: function() {
      const startYear = new Date().getMonth() >= 8 ? new Date().getFullYear() + 1 : new Date().getFullYear();

      return !!this?.classYear && this.classYear >= startYear;
    },
    loginUrl: function() {
      const profileKey = new URLSearchParams(window.location.search).get("k");
      const loginUrl = new URL("/identify", window.location);
      const recruitsUrl = new URL("/recruits", window.location);
      const filters = {
        notCommitted: true,
        classYear: [{ label: `${this.classYear}`, value: this.classYear }],
      };

      recruitsUrl.searchParams.append("filters", btoa(JSON.stringify(filters)));

      loginUrl.searchParams.append("profile-key", profileKey);
      loginUrl.searchParams.append("destination", recruitsUrl.toString());

      return loginUrl.toString();
    },
    similarAthletesCount: function() {
      return Math.floor(this.similarUncommittedAthletesCount / 100) * 100;
    },
    shouldShow: function() {
      return (
        this.hasValidClassYear &&
        this.isUsingProfileKey &&
        (this.isLoggedOut || this.authUsingProfileKey) &&
        this.similarUncommittedAthletesCount > 100
      );
    },
  },
};
</script>
